<template>
  <div class="d-flex flex-column fill-height">
    <div class="flex">
      <h4 v-if="!hideTitle" :class="titleCssClass + ' text-center'">
        {{ getParameter?.label }}
      </h4>
      <p v-if="!hideDescription" v-html="getParameter?.descriptif" :class="hideTitle && titleCssClass"></p>
      <div class="title-section">
        <slot></slot>
      </div>
    </div>
    <!-- Doc dropzone -->
    <vue-dropzone ref="myVueDropzone"
                  :useCustomSlot="true"
                  id="dropzone"
                  @vdropzone-upload-progress="uploadProgress"
                  :options="dropzoneOptions"
                  @vdropzone-file-added="fileAdded"
                  @vdropzone-sending-multiple="sendingFiles"
                  @vdropzone-success-multiple="success"
                  @vdropzone-queue-complete="complete">
      <div class="dropzone-container d-flex flex-column">
        <div class="file-selector d-flex justify-center">
          <NuageIcon />
          <p class="align-self-center">
            Déposez un fichier<br />
            (30 Mo maximum)
          </p>
        </div>
      </div>
    </vue-dropzone>

    <AttachmentList :tempAttachments="getTempAttachments"
                    :attachments="getAttachments"
                    :existingAttachments="getDocs"
                    @removetempfile="removeTempFile"
                    @removeuploadedfile="removeUploadedFile" />

    <div>
      <v-input :value="isValid" :rules="rules.attachements"/>
    </div>

  </div>
</template>

<script>
	import vue2Dropzone from "vue2-dropzone";
	import "vue2-dropzone/dist/vue2Dropzone.min.css";
	import AttachmentList from "./AttachmentList";
	import { mapActions, mapGetters } from "vuex";
	import NuageIcon from "../../assets/svg/NuageIcon.vue"

	export default {
    props: {
      filePrefix: {
        type: String,
        default: null,
      },
      // Nombre de fichiers attendu
      minRequired: {
        type: Number,
        default: 1,
      },
      hideTitle: {
        type: Boolean,
        default: false,
      },
      hideDescription: {
        type: Boolean,
        default: false,
      },
    },
		components: {
			vueDropzone: vue2Dropzone,
			AttachmentList: AttachmentList,
			NuageIcon: NuageIcon
		},
		data: function () {
			return {
				fileType: 0,
        encodedFileId: null,
				attachments: [],
				tempAttachments: [],
        rules: {
          attachements: [(v) => v || (this.minRequired > 1
              ? `Au moins ${this.minRequired} documents sont requis`
              : 'Le document est requis')],
        },
        dropzoneOptions: {
					// The Url Where Dropped or Selected files will be sent
					url: process.env.VUE_APP_UPLOADFILE_API_DEMANDEADMISSION,
					// The way you want to receive the files in the server
					paramName: function (n) {
						return "file[]";
					},
					includeStyling: false,
					previewsContainer: false,
					thumbnailWidth: 250,
					thumbnailHeight: 140,
					uploadMultiple: true,
					parallelUploads: 1,
					addRemoveLinks: true,
					autoProcessQueue: false,
					updatedDocs: [],
				},
			};
		},
		computed: {
			...mapGetters({
				contactId: "DemandeAdmission/GET_CONTACTID",
				getAllDocuments: "Documents/GET_ALL_DOCUMENTS",
        getDocumentsTextes: "Parametrage/getDocumentsTextes",
			}),
			getParameter() {
				return this.getDocumentsTextes.find(d => d.typeDocumentId == this.fileType);
			},
			titleCssClass() {
				return this.minRequired > 0 && this.getParameter?.label && "cssRequired";
			},
			getTempAttachments() {
				return this.tempAttachments;
			},
			getAttachments() {
				return this.attachments;
			},
      getAttachmentsCount() {
        const tempCount = this.tempAttachments ? this.tempAttachments.length : 0;
        const existingCount = this.getAllDocuments ? this.getAllDocuments.filter(d => d.type != null && d.type.id == this.fileType).length : 0;
        return tempCount + existingCount;
      },
			isValid() {
				return this.getAttachmentsCount >= this.minRequired;
			},
			getDocs() {
				const docs = this.getAllDocuments.filter(d => d.type != null && d.type.id == this.fileType);
				this.updateCount();
				return docs;
			},
		},
		mounted() {
			this.getTypeOfDocument();
		},
		created() {
			this.fetchItems();
		},
		methods: {
			...mapActions({
				deleteDocumentByEncodedId: "Documents/deleteDocumentByEncodedId",
        fetchDocumentsTextes: "Parametrage/fetchDocumentsTextes",
      }),
			async fetchItems() {
				await this.fetchDocumentsTextes()
			},
			getTypeOfDocument: function () {
        switch (this.filePrefix) {
          case "identité":
            this.fileType = this.$catalogues.typeDocument.preuveIdentite
            break
          case "form_univ":
            this.fileType = this.$catalogues.typeDocument.universitaire
            break
          case "form_exp":
            this.fileType = this.$catalogues.typeDocument.expPro
            break
          case "instance_justificatif":
            this.fileType = this.$catalogues.typeDocument.instanceJustificatif
            break
          case "disciplinaire":
            this.fileType = this.$catalogues.typeDocument.declarationDisciplinaire
            break
          case "decision":
            this.fileType = this.$catalogues.typeDocument.declarationDecisionnelle
            break
          case "judiciaire":
            this.fileType = this.$catalogues.typeDocument.declarationJudiciaire
            break
          case "form_clf":
            this.fileType = this.$catalogues.typeDocument.formationClf
            break
          case "form_equiv_attestation_employeur_prp":
            this.fileType = this.$catalogues.typeDocument.employeurPrp
            break
          case "form_employeur":
          case "form_equiv_attestation_employeur":
            this.fileType = this.$catalogues.typeDocument.employeur
            break
          case "form_preuve":
            this.fileType = this.$catalogues.typeDocument.preuve
            break
          case "form_equiv_traduction":
            this.fileType = this.$catalogues.typeDocument.equivalenceTraduction
            break
          case "form_equiv_diplome":
            this.fileType = this.$catalogues.typeDocument.equivalenceDiplome
            break
          case "form_equiv_notes":
            this.fileType = this.$catalogues.typeDocument.equivalenceNotes
            break
          case "form_equiv_description":
            this.fileType = this.$catalogues.typeDocument.equivalenceDescription
            break
          case "form_equiv_plan_cours":
            this.fileType = this.$catalogues.typeDocument.equivalencePlanCours
            break
          case "form_equiv_plan_cours_prp":
            this.fileType = this.$catalogues.typeDocument.equivalencePlanCoursPrp
            break
          case "form_equiv_attestation_stage_prp":
            this.fileType = this.$catalogues.typeDocument.equivalenceAttestationStagePrp
            break
          case "form_equiv_attestation_stage":
            this.fileType = this.$catalogues.typeDocument.equivalenceAttestationStage
            break
          case "form_equiv_eval_comparative":
            this.fileType = this.$catalogues.typeDocument.equivalenceEvalComparative
            break
          case "form_equiv_curriculum_prp":
            this.fileType = this.$catalogues.typeDocument.equivalenceCurriculumPrp
            break
          case "form_equiv_curriculum":
            this.fileType = this.$catalogues.typeDocument.equivalenceCurriculum
            break
          case "form_equiv_attestation_benevole":
            this.fileType = this.$catalogues.typeDocument.equivalenceAttestationBenevole
            break
          case "form_lettre_engagement_formation":
            this.fileType = this.$catalogues.typeDocument.lettreEngagementFormationAppoint
            break
          case "form_attestation_formation":
            this.fileType = this.$catalogues.typeDocument.attestationParticipationFormations
            break
          case "form_lettre_motivation_paear":
            this.fileType = this.$catalogues.typeDocument.lettreMotivationPaear
            break
          case "form_experience_pro_lettre_recommandation":
            this.fileType = this.$catalogues.typeDocument.experienceProLettreRecommandation
            break
          case "form_declaration_assurance":
            this.fileType = this.$catalogues.typeDocument.declarationAssurance
            break
        }
      },
			// function called for every file dropped or selected
			fileAdded(file) {
				//console.log("File Dropped => ", file);
				// Construct your file object to render in the UI
				const attachment = {};
				attachment._id = file.upload.uuid;
				attachment.title = file.name;
				attachment.type = "file";
				attachment.extension = "." + file.type.split("/")[1];
				attachment.user = JSON.parse(localStorage.getItem("user"));
				attachment.content = "File Upload by Select or Drop";
				attachment.thumb = file.dataURL;
				attachment.thumb_list = file.dataURL;
				attachment.isLoading = true;
				attachment.progress = null;
				attachment.size = file.size;

				this.tempAttachments = [...this.tempAttachments, attachment];
				this.updateCount();
			},
			updateCount() {
				this.$emit("refreshEvent", this.getAttachmentsCount);
			},
			// a middle layer function where you can change the XHR request properties
			sendingFiles(files, xhr, formData) {
				formData.append("linkedId", this.encodedFileId);
				formData.append("prefix", this.filePrefix);
				if (this.contactId) {
					formData.append("contactId", this.contactId);
				}
			},
			// function where we get the upload progress
			uploadProgress(file, progress, bytesSent) {
				this.$emit("input");
				this.$emit("uploadEvent", true);

				//console.log("File Upload Progress", progress);
				this.tempAttachments.map((attachment) => {
					if (attachment.title === file.name) {
						attachment.progress = `${Math.floor(progress)}`;
					}
				});
			},
			// called on successful upload of a file
			success(file, response) {
				console.log("Response is ->", response);
				this.$emit("successEvent");
			},
			complete() {
				this.$emit("completeEvent");
			},
			startUpload(encodedFileId, type) {
				if (type == "contact") {
					this.$refs.myVueDropzone.setOption("url", process.env.VUE_APP_UPLOADFILE_API_CONTACT);
				} else if (type == "demandeAdmission") {
					this.$refs.myVueDropzone.setOption("url", process.env.VUE_APP_UPLOADFILE_API_DEMANDEADMISSION);
				} else if (type == "demandeInscription") {
					this.$refs.myVueDropzone.setOption("url", process.env.VUE_APP_UPLOADFILE_API_DEMANDEINSCRIPTION);
				}
        this.encodedFileId = encodedFileId

				console.log("Start of StartUpload in Attachment.vue with id : ", this.encodedFileId);
				if (this.tempAttachments && this.tempAttachments.length > 0) {
					this.$refs.myVueDropzone.processQueue();
				} else {
					this.$emit("completeEvent");
				}
			},
			removeTempFile(index) {
				this.tempAttachments.splice(index, 1);
				this.updateCount();
			},
			removeAllTempFile() {
				this.tempAttachments.splice(0, this.tempAttachments.length);
				this.updateCount();
			},
			removeUploadedFile(file) {
				this.deleteDocumentByEncodedId(file.id);
				console.log("removed file", file);
			},
		}
	};
</script>

<style scoped>
	figure {
    margin: 0 15px 0 0;
  }

	.title-section {
		text-align: center;
		color: rgba(0, 0, 0, 0.5);
	}

	.topBar {
		margin-bottom: 16px;
		max-width: 80%;
		opacity: 53%;
	}

	.file-selector {
		padding: 15px;
		font-weight: 600;
		color: #4e5b69;
	}

  .file-selector p {
    margin: 0;
  }

	.dropzone-container {
		border: 1px dashed #ccc;
		border-radius: 15px;
	}
</style>
<style>
.vue-dropzone {
  border: 0;
  font-family: Arial, sans-serif;
  letter-spacing: 0.2px;
  color: #777;
  -webkit-transition: 0.2s linear;
  transition: 0.2s linear;
}

.dropzone .dz-message {
  margin: 0;
}
</style>